import { useAuthStoreShallow } from "@/features/authentication";
import {
  FEATURE_FLAGS,
  isOnFeatureFlag,
  useFeatureFlag,
} from "@/lib/feature-flags";

/**
 * STANDALONE VERSIONS, BEHIND THEIR FLAG.
 *
 * A version created on its own -- "Create new" offering a version as well as
 * a story, the Creator lite's "Create version", the funnel's version target,
 * the library bar's "Create version", the Versions tab on the template step
 * -- shows only where the flag is on. With it off every one of those doors is
 * what it was before this work, and a Creator lite creates nothing at all.
 *
 * What already exists needs no flag: a version's origin badge, the host page
 * kept out of story lists and analytics, the settings-first Share -- those
 * only ever fire for versions that were created through the doors above.
 */
export const useStandaloneVersions = (): boolean =>
  useFeatureFlag(FEATURE_FLAGS.STANDALONE_VERSIONS);

/** The same answer outside React -- for store-level checks. */
export const isStandaloneVersionsOn = (): boolean =>
  isOnFeatureFlag(FEATURE_FLAGS.STANDALONE_VERSIONS);

/**
 * A Creator lite building from the org's own material only: Team slides,
 * the org's stories and versions -- none of Storydoc's templates or layouts,
 * no blank start, no new folders. The rule exists because a version is
 * theirs to make, so it holds only while the flag says so; off, a Creator
 * lite sees what they always saw.
 */
export const useCreatorLiteSourceRules = (): boolean => {
  const on = useStandaloneVersions();
  const isCreatorLite = useAuthStoreShallow((s) => s.isCreatorLite);
  return on && isCreatorLite;
};
